import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-success-checkmark';
export var ID = 'icon-success-checkmark';
/* eslint-disable max-len */

export var SVGSuccessCheckmark = function SVGSuccessCheckmark() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 106 106"
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("circle", {
    fill: "#76A40B",
    cx: "53",
    cy: "53",
    r: "53"
  }), React.createElement("path", {
    d: "M32.565 51.105l13.538 10.21 28.42-37.207c1.566-2.236 4.648-2.78 6.883-1.214l.376.277c2.235 1.566 2.78 4.647 1.213 6.883L51.982 77.827c-1.17 1.672-2.333 2.253-4.372 2.388-2.04.135-3.273-.622-4.497-1.846L25.466 58.19c-1.955-1.952-1.955-5.12 0-7.074l.024-.012c1.954-1.954 5.12-1.954 7.075 0z",
    fill: "#FFF"
  })));
};
/* eslint-disable max-len */

var SuccessCheckmark = function SuccessCheckmark(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGSuccessCheckmark
  });
};

SuccessCheckmark.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default SuccessCheckmark;